<script>
import store from '@store';
import useVuelidate from '@vuelidate/core';
import {email, required} from '@vuelidate/validators';

/* COMPOSANTS */
import AkDialog from '@components/general/AkDialog';
import AkInputText from '@components/v2/input/AkInputText.vue';

/* SERVICES */
import pwdService from '@services/pwdService';
import permissionsMixin from '@mixins/permissionsMixin';
import AkButtonValidation from '../components/v2/general/AkButtonValidation.vue';

export default {
  components: {AkDialog, AkButtonValidation, AkInputText},
  mixins: [permissionsMixin],
  setup() {
    return {v$: useVuelidate()};
  },
  metaInfo() {
    return {
      title: '',
    };
  },
  data() {
    return {
      submitted: false,
      messages: [],
      pwd: {
        emailPwd: '',
      },
      user: {
        username: '',
        password: '',
      },
    };
  },
  validations() {
    return {
      user: {
        username: {required},
        password: {required},
      },
      pwd: {
        emailPwd: {required, email},
      },
    };
  },
  methods: {
    tryToLogInAuto() {
      this.$refs.loginBtn.load();
      this.tryToLogIn();
    },
    tryToLogIn() {
      this.messages = [];
      this.submitted = true;
      this.v$.user.$touch();
      if (this.v$.user.$error) {
        this.$refs.loginBtn.init();
        return;
      }

      return store
        .dispatch('logIn', {
          username: this.user.username,
          password: this.user.password,
        })
        .then(() => {
          this.$refs.loginBtn.init();
          //TODO IF PRESTATAIRE -> Redirect to special page to download APP
          if (this.isPrestataire()) {
            this.addErr(this.$t('unauthorized_prestataire'));
            store.dispatch('logOutSilent');
          } else {
            if (this.isDeveloper()) {
              this.$router.push({name: 'developerReservation'});
            } else {
              // Redirect to the originally requested page, or to the home page
              if (this.isAdmin()) {
                this.$router.push({name: 'settingsSocieteGuestadom'});
              } else {
                if (store.state.userInformation.resetPassword) {
                  this.$router.push({name: 'resetPwd'});
                } else {
                  // Redirect to the originally requested page, or to the home page
                  this.$router.push(this.$route.query.redirectFrom || {name: 'home'});
                }
              }
            }
          }
        })
        .catch((error) => {
          this.$refs.loginBtn.init();
          this.messages = [];
          let status = error.response.status;
          if (status === 404) this.addErr(this.$t('login_not_found'));
          else if (status === 401) this.addErr(this.$t('bad_pwd'));
          else if (status === 403) {
            if (error.response.data.error === 'UNAUTHORIZED_CLIENT_CLEANER')
              this.addErr(this.$t('unauthorized_cleaner'));
            else this.addErr(this.$t('not_enabled'));
          } else this.addErr(this.$t('unknow_error'));
        });
    },
    addErr(msg) {
      this.messages.push({closable: true, severity: 'error', content: msg});
    },
    addSuccess(msg) {
      this.messages.push({closable: true, severity: 'success', content: msg});
    },

    displayDialogUpdatePwd() {
      this.$refs.dialogUpdatePwd.show();
    },
    sendPwdReset() {
      this.v$.pwd.$touch();
      if (this.v$.pwd.$error) {
        this.$refs.dialogUpdatePwd.init();
        return;
      }

      let loader = this.$loading.show({
        canCancel: false,
        backgroundColor: '#FFF',
        color: '#064CDB',
        isFullPage: true,
      });
      pwdService
        .resetPwd(this.pwd.emailPwd)
        .then(() => {
          this.resetPwdUpdate(loader);
        })
        .catch(() => {
          this.resetPwdUpdate(loader);
          //this.addErr(this.$t("login_not_found"));
        })
        .finally(() => {
          this.addSuccess("Le mail de réinitialisation de votre mot de passe vient d'être envoyé.");
        });
    },
    resetPwdUpdate(loader) {
      loader.hide();
      this.messages = [];
      this.$refs.dialogUpdatePwd.hide();
      this.pwd = {
        emailPwd: '',
      };
    },
  },
};
</script>

<template>
  <div class="h-screen flex flex-col md:flex-row">
    <div
      class="w-full absolute bottom-0 left-0 right-0 z-10 md:relative md:w-2/4 lg:w-2/5 2xl:w-1/4 h-3/5 md:h-full flex justify-center order-2 md:order-1 rounded-t-xl md:rounded-none bg-white">
      <div class="w-10/12 xl:w-8/12 flex flex-col items-center gap-5 justify-center">
        <img src="@refonte/img/guestadom_login.svg" alt="Logo guestadom" />
        <span class="font-inter text-dark font-semibold text-lg">Rentrez vos informations de connexion</span>
        <form class="w-full flex flex-col gap-5" @submit.prevent="tryToLogInAuto">
          <AkInputText
            :label="$t('user.email')"
            :display-label="false"
            v-model="user.username"
            :submitted="submitted"
            :validator="v$.user.username" />
          <AkInputText
            :label="$t('user.password')"
            :display-label="false"
            v-model="user.password"
            :submitted="submitted"
            :validator="v$.user.password"
            input-type="password" />
          <div class="flex w-full justify-between items-center">
            <span
              class="font-inter text-sm text-primary-gradient font-medium cursor-pointer"
              @click="this.displayDialogUpdatePwd()"
              >Mot de passe oublié ?</span
            >
            <AkButtonValidation @action="tryToLogInAuto" ref="loginBtn" label="Se connecter" />
          </div>
        </form>
      </div>
      <div class="flex flex-col absolute bottom-[16px] max-w-[90%] gap-2">
        <Message v-for="msg of messages" :key="msg.content" :closable="msg.closable" :severity="msg.severity">
          {{ msg.content }}
        </Message>
      </div>
    </div>
    <div
      class="w-full absolute top-0 left-0 right-0 md:relative md:w-2/4 lg:w-3/5 2xl:w-3/4 h-[45%] md:h-screen bg-cover placeholder-background bg-center order-1 md:order-2"></div>
  </div>
  <!--<div class="main-layout">
    <div class="center-block-login">
      <div class="login-layout">
        <div class="mb-150">
          <div class="row justify-content-center align-items-center mt-2">
            <div class="d-flex align-items-center">
              <span class="header-title">{{ $t('welcome') }}</span>
            </div>
          </div>
          <div class="row justify-content-center align-items-center mt-2">
            <div class="col-lg-9 align-items-center text-center">
              <span class="header-subtitle">{{ $t('welcome-title') }}</span>
            </div>
          </div>
          <div class="row justify-content-center align-items-center mt-2">
            <div class="col-lg-9 align-items-center text-center">
              <Message v-for="msg of messages" :key="msg.content" :closable="msg.closable" :severity="msg.severity">
                {{ msg.content }}
              </Message>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="login-container">
    <img alt="logo" class="logo-shape" src="@assets/logo_min.svg" />
    <form class="full-width" @submit.prevent="tryToLogIn">
      <div class="login-shape">
        <div class="input-layout">
          <AkInputText
            className="full-width"
            v-model="user.username"
            :disabled="false"
            :display-label="false"
            :placeholder="$t('user.email')"
            :submitted="submitted"
            input-class="login-input"
            label="" />
          <AkInputText
            className="full-width"
            v-model="user.password"
            :disabled="false"
            :display-label="false"
            :placeholder="$t('user.password')"
            :submitted="submitted"
            input-class="login-input"
            input-type="password"
            label="" />
          <div class="forgotten-pwd-layout">
            <a class="pointer forgotten-pwd-title" @click="displayDialogUpdatePwd">{{ $t('pwd_forget') }}</a>
          </div>
          <div class="flex-center full-width">
            <button class="btn login-btn">
              {{ $t('sign_in') }}
            </button>
          </div>
        </div>
      </div>
    </form>

  </div>
  -->
  <AkDialog
    ref="dialogUpdatePwd"
    :title="$t('pwd_forget')"
    :validate-label="$t('send')"
    width="450px"
    @validate="sendPwdReset()">
    <div class="confirmation-content">
      <AkInputText
        v-model="pwd.emailPwd"
        :label="$t('pwd_forget_enter_mail')"
        :validator="v$.pwd.emailPwd"
        class-name="col-md-12" />
    </div>
  </AkDialog>
</template>
<style lang="scss" scoped>
@import '@refonte/index.css';
</style>
